import React from 'react';

class CheckedCheckbox extends React.Component {
  render(){
    return(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="16"
      >
        <g
          id="checkbox/checked"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            id="Rectangle"
            stroke="#545454"
            x="0.5"
            y="0.5"
            width="15"
            height="15"
          />
          <g
            id="check"
            transform="translate(1.000000, 1.000000)"
            fill="#545454"
          >
            <path
              d="M17.1779519,3.45459797 C17.1779519,3.17599999 17.0666236,2.897402 16.8662327,2.69681146 L15.3521684,1.18123844 C15.1517776,0.980647891 14.8734569,0.869208698 14.5951363,0.869208698 C14.3168156,0.869208698 14.038495,0.980647891 13.8381041,1.18123844 L6.53497043,8.5027934 L3.26191965,5.21533721 C3.06152879,5.01474667 2.78320814,4.90330747 2.5048875,4.90330747 C2.22656685,4.90330747 1.94824621,5.01474667 1.74785534,5.21533721 L0.23379104,6.73091023 C0.033400176,6.93150078 -0.0779280817,7.21009876 -0.0779280817,7.48869674 C-0.0779280817,7.76729472 0.033400176,8.04589271 0.23379104,8.24648325 L4.26387397,12.280582 L5.77793827,13.796155 C5.97832914,13.9967456 6.25664978,14.1081848 6.53497043,14.1081848 C6.81329107,14.1081848 7.09161172,13.9967456 7.29200258,13.796155 L8.80606688,12.280582 L16.8662327,4.21238448 C17.0666236,4.01179393 17.1779519,3.73319595 17.1779519,3.45459797 L17.1779519,3.45459797 Z"
              id="Icons/Check"
            />
          </g>
        </g>
      </svg>
    );
  }
}

export default CheckedCheckbox;
